<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
import axios from 'axios'
import { orderBy } from 'lodash-es'
export default {
  name: 'InfoShow',
  props: {
    id: { required: true },
  },
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      artiste: '',
      showBack: false,
      openBasic: false,
      openChanteur: false,
      openSong: false,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  computed: {
    image_background () {
      var temp = ''
      var find = false
      if (this.data_tri) {
        for (var i = 0; i < this.data_tri.length; i++) {
          /*eslint-disable*/
          if (this.data_tri[i].container.tag_visibles.length > 0 && this.data_tri[i].container.tag_visibles[0].name === 'fono') {
          /*eslint-enable*/
            // console.log('trouvé')
            temp = this.data_tri[i].container.medias[0].image.url
            // console.log(temp)
            find = true
          }
        }
      }
      if (!find) {
        temp = '~@/../static/fond1.jpg'
      }
      return temp
    },
    video_background () {
      if (this.data_tri) {
        // console.log(this.data_tri[this.data_tri.length - 1])
        var temp = this.data_tri[this.data_tri.length - 1].container.description
        temp = temp.replace(/<{1}[^<>]{1,}>{1}/g, '')
        return '~@/../static/video/videos_transitions/videos_background_songsrecording/' + temp
      }
    },
    fiche_artiste () {
      if (this.container) {
        // console.log(this.container)
        return this.container.tag_visibles[0].name
      } else {
        return false
      }
    },
    data_tri () {
      if (this.page) {
        // console.log(orderBy(this.page.page_containers, ['position'], ['asc']))
        return orderBy(this.page.page_containers, ['position'], ['asc'])
      }
    },
  },
  apollo: {
    page: {
      query: gql `query page($id: String!){
        page(id: $id){
          id titre description page_containers{
            id position container{
              id description titre tag_visibles{
                id name
              } medias{
                id position image{
                  description titre url
                } mediable_type video{
                  description link minutage titre url
                }
              }
            }
          }
        }
      }`,
      variables () {
        return {id: this.id}
      },
      fetchPolicy: 'cache-first',
      update: data => data.page,
    },
    container: {
      /*eslint-disable*/
      query: gql `query container($id: String!){
        container(id: $id){
          id categorie_list description titre medias{
            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}
          } tag_visibles{
            id name
          }
        }
      }`,
      variables () {
        return { id: this.id }
      },
      fetchPolicy: 'cache-first',
      skip () { return !this.id },
      update: data => data.container,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
    getVid: function (url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '')
          /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g
        var iframe = 'https://www.youtube.com/embed/$1'
          /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1])
        // console.log(link)
        return link
      } else {
        axios.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          // console.log(response.data)
          var temp = response.data
          // console.log(temp)
          // console.log('test')
          // console.log(temp)
          // console.log(temp.html)
          this.valvid = temp.html
          return temp.html
        })
      }
    },
    async getHTML (url) {
      // console.log('test')
      var h = Math.round(document.documentElement.clientHeight * 0.3)
      var w = Math.round(document.documentElement.clientWidth * 0.72)
      try {
        /*eslint-disable*/
        var temp = await axios.get('https://vimeo.com/api/oembed.json?url=' + url + '&width='+ w +'&height=' + h )
        /*eslint-enable*/
      } finally {
        // console.log(temp.data.thumbnail_url_with_play_button)
        // console.log(temp.data.html)
        this.valvid = temp.data.html
        this.thumbnail = temp.data.thumbnail_url_with_play_button
      }
    },
    isVimeo: function (url) {
      if (url.includes('vimeo')) {
        this.getHTML(url)
        return true
      } else {
        return false
      }
    },
    showMusic () {

    },
    nextSlide () {
      this.$refs.carous.next()
    },
    previousSlide () {
      this.$refs.carous.previous()
    },
    checkSlide (direction, vid) {
      if (direction === 'next') {
        if (this.$refs.infogene.slide === 1) {
          this.showBack = true
          // this.$refs.videocan.showVideo = true
          this.$refs.videocan.play()
        } else {
          if (this.$refs.videocan.playing) {
            this.$refs.videocan.pause()
            this.$refs.videocan.setTime(0)
          }
          this.showBack = false
        }
        this.$refs.infogene.next()
      } else if (direction === 'previous') {
        if (this.$refs.infogene.slide === 0) {
          this.showBack = true
          // this.$refs.videocan.showVideo = true
          this.$refs.videocan.play()
        } else {
          if (this.$refs.videocan.playing) {
            this.$refs.videocan.pause()
            this.$refs.videocan.setTime(0)
          }
          this.showBack = false
        }
        this.$refs.infogene.previous()
      }
    },
    closeMod () {
      // console.log('hey')
      this.$refs.videocan.play()
      this.$refs.songModal.close()
    },
    closeBasic () {
      this.openBasic = false
    },
    openModalBasic () {
      this.openBasic = true
      this.$refs.basicModal.open()
    },
    closeChanteur () {
      this.openChanteur = false
    },
    modalChanteur () {
      this.openChanteur = true
      this.$refs.chanteurModal.open()
    },
    closeSong () {
      this.openSong = false
      this.$refs.videocan.play()
    },
    modalSong () {
      this.openSong = true
      this.$refs.videocan.pause()
      this.$refs.songModal.open()
    },
    continueVideo () {
      this.$refs.videocan.play()
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexture(:style="{ backgroundImage: `url(${image_background})`}")
  //- div.backgroundimg
  div
  div.info_show_song.flex
    Canvas-video(ref='videocan', v-show='showBack', :src='video_background', :cover='true', :loop='true', style="z-index: -9; width:100vw !important; height: 137vh !important; top:-20vh !important; position: fixed !important;")
    q-carousel(ref='infogene', infinite, no-swipe)
      div.navigationsongs
        i.fa.fa-arrow-left.historyarrowleft.fa-3x-ns.fa-2x(@click="checkSlide('previous')")
        i.fa.fa-arrow-right.historyarrowright.fa-3x-ns.fa-2x(@click="checkSlide('next')")
      div(slot='slide')
        img.logosongs(:src='data_tri[0].container.medias[0].image.url', width="200px")
        div.titrehistory.flex.mv3
          hr.white.w-10.w-20-ns.mh0
          div.history.white.ttu.mh3 About the song
          hr.white.w-10.w-20-ns.mh0
        div.introhistory(v-html='page.description')
        q-btn.historybtn(@click='openModalBasic()', label='Open') Read more
        //- i.fa.fa-arrow-left.historyarrowleft.fa-3x-ns.fa-2x(@click="checkSlide('previous', 'true')")
        //- i.fa.fa-arrow-right.historyarrowright.fa-3x-ns.fa-2x(@click="checkSlide('next', 'false')")
      div(slot='slide')
        img.logosongs(:src='data_tri[0].container.medias[0].image.url', width="200px")
        div.titrehistory.flex.mv3
          hr.white.w-10.w-20-ns.mh0
          div.history.white.ttu.mh3 Songwriter
          hr.white.w-10.w-20-ns.mh0
        div.introhistory(v-html='data_tri[1].container.description')
        q-btn.historybtn(@click='modalChanteur()', label='Open') Read more

      div(slot='slide')
        div(style='z-index: 80; top: 0;')
          img.logosongs(:src='data_tri[0].container.medias[0].image.url', width="200px")
          div.titrehistory.flex.mv3
            hr.white.w-10.w-20-ns.mh0
            div.history.white.ttu.mh3 Song Recording
            hr.white.w-10.w-20-ns.mh0
          div.introhistory(v-html='data_tri[4].container.description')
          q-btn.historybtn(@click='modalSong()') play
          //- i.fa.fa-arrow-left.historyarrowleft.fa-3x-ns.fa-2x(@click="checkSlide('previous', 'false')")
          //- i.fa.fa-arrow-right.historyarrowright.fa-3x-ns.fa-2x(@click="checkSlide('next', 'false')")
    //- q-modal.videosong(ref='songModal', :content-css="{minHeight: '95vh'}")
    q-modal(ref="songModal", minimized, @close='closeSong()', :content-css="{padding: '-1px', background: 'transparent'}")
      //- i.fa.fa-close.pl2.fa-lg(@click="closeMod()")
      div(v-if='openSong', v-for="med in data_tri[4].container.medias")
        div(v-if="med.video")
          div(v-if="isVimeo(med.video.link)")
            div(v-html='valvid')
          div(v-else)
             q-video(:src='getVid(med.video.link)', style="width:80vw; height:45vh;")
             //- p {{med.video.titre}}
    q-modal(ref='basicModal', minimized, @close='closeBasic()', :content-css="{background: 'black', border: 'solid 2px white'}")
      div.bloctitre {{data_tri[2].container.titre}}
      div.soustitre(v-if='openBasic', v-for="med in data_tri[2].container.medias")
        div(v-if="med.image")
          img(:src="med.image.url", width="90%" height="90%")
      div.blocdescription2
        p(v-html="data_tri[2].container.description")
      div.soustitre(v-if='openBasic', v-for="med in data_tri[2].container.medias")
        div(v-if="med.video")
          div(v-if="isVimeo(med.video.link)")
            div(v-html='valvid')
          div(v-else)
            q-video(:src='getVid(med.video.link)', style="height: 300px;")
            p {{med.video.titre}}
    q-modal(ref='chanteurModal', minimized, @close='closeChanteur', :content-css="{background: 'black', border: 'solid 2px white'}")
      div.bloctitre {{data_tri[3].container.titre}}
      div.blocdescription2
        p(v-html="data_tri[3].container.description")
      div.soustitre(v-for="med in data_tri[3].container.medias")
        div(v-if="med.image")
          img(:src="med.image.url", width="90%" height="90%")
          //- img(v-if="med.image", :src="med.image.url")
          //- p {{med.image.description}}
      div.soustitre(v-if='openChanteur',v-for="med in data_tri[3].container.medias")
        div(v-if="med.video")
          div(v-if="isVimeo(med.video.link)")
            div(v-html='valvid')
          div(v-else)
             q-video(:src='getVid(med.video.link)', style="width: 300px;")
             p {{med.video.titre}}
      //- div More songs by {{data_tri[3].container.titre}}
        // div(v-for='chanson in containers_chanson_artiste')
          router-link(:to="{name: 'info-song-show', params: {id: chanson.id} }") {{chanson.titre}}
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*ANIMATIONS*/
.backgroundtexture{
  -moz-animation: fadeIn 2;
  -webkit-animation: fadeIn 2s;
  animation: fadeIn 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;

}
.logosongs{
  -moz-animation: zoomIn 2s 2s;
  -webkit-animation: zoomIn 2s 2s;
  animation: zoomIn 2s 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.titrehistory{
  -moz-animation: zoomIn 2s 2.3s;
  -webkit-animation: zoomIn 2s 2.3s;
  animation: zoomIn 2s 2.3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.introhistory{
  -moz-animation: fadeInUp 2s 3s;
  -webkit-animation: fadeInUp 2s 3s;
  animation: fadeInUp 2s 3s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.historybtn{
  -moz-animation: zoomIn 1s 4s;
  -webkit-animation: zoomIn 1s 4s;
  animation: zoomIn 1s 4s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.navigationsongs{
  -moz-animation: fadeIn 1s 6s;
  -webkit-animation: fadeIn 1s 6s;
  animation: fadeIn 1s 6s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*ANIMATIONS END*/
/*mobile*/
.minimized{
  background:rgba(0,0,0,0.8)!important;
}
.layout-page-container{
  height: 100% !important;

}
.modal-content::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
.soustitre{
  & iframe{
    display:block;
    margin: 0 auto;
  }
  & img{
    display:block;
    margin: 0 auto;
  }
}
@media only screen and (min-width: 320px){
  .backgroundtexture{
    /*background-image: url("~@/assets/imgs_bg/fond1.jpg");*/
    background-size: cover;
    background-position: center;
    height: 100vh;
    width:100vw;
    z-index:-10;
    position:fixed;
    background-color:#3a3b4a;
    background-blend-mode: multiply;
  }
  .bloctitre {
    width: 250px;
    font-family: Abril Fatface;
    font-size: 35px;
    margin: 20px auto 20px;
    /*background-color: red;*/
    color:white;
    padding: 20px 20px 20px 20px;
    border-style: double;
    border-width: 10px;
    border-color:white;
    text-align: center;
  }
  .blocdescription2{
    & p {
      font-size: 20px!important;
      margin-bottom: 22px;
      padding:30px;
      line-height: 24px;
      text-align: left;
      max-width:800px;
      text-indent: 22px;
      color:white!important;
      font-family: Crimson Text;
      & p{
        font-size: 20px!important;

      }
    }
  }
  .historyarrowleft{
    position: fixed;
    color:white;
    left:20px;
    top:50%;
  }
  .historyarrowright{
    position: fixed;
    color:white;
    right:20px;
    top:50%;
  }
  .titrehistory{
    justify-content: center;
  }
  .logosongs{
    margin-top:5%;
    margin-bottom:30px;
  }
  .history{
  font-family: Abril Fatface;
  font-size:18px;
  }
  .introhistory{
    color:white;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 1);
    width:80%;
    font-family: Crimson Text!important;
    font-size:18px;
    font-style: italic;
    text-align: center;
    margin:0 auto;
    line-height:22px;
  }
  .historybtn{
    border: solid white 2px!important;
    font-family: Abril Fatface!important;
    text-transform: uppercase!important;
    font-size: 18px;
    width:175px!important;
    color:white!important;
    margin-top: 40px!important;
    background-color: rgba(0,0,0,0.7)
  }
  .info-show-song {
  padding: 70px 35px 40px 35px;
  }
  .q-carousel-track{
    padding: 30px 5px 10px 5px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
  .bloctitre {
    width:300px;
  }
}

/*TABLET*/

@media only screen and (min-width: 768px) and (max-width:960px){
  .bloctitre {
    width:300px;
  }
  .logosongs{
    margin-top:30%;
  }
  .history{
  font-family: Abril Fatface;
  font-size:18px;
  }
  .introhistory{
    width:70%;
  }
  .historybtn{
    border: solid white 1px;
    font-family: Abril Fatface;
    text-transform: uppercase;
    color:white;
    margin-top: 20px;
  }
  .bloctitre {
    width: 350px;
    margin: 20px auto 20px;
  }

  .info-show-song {
    width: 85%;
    top: 60px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 961px){

  .bloctitre {
    width:300px;
  }
  .introhistory{
    color:white;
    width:50%;
    text-align: center;
    margin:0 auto;
    line-height:20px;
  }
  .historyarrowleft{
    position: fixed;
    color:white;
    left:20px;
    top:50%;
  }
  .historyarrowright{
    position: fixed;
    color:white;
    right:20px;
    top:50%;
  }
  .logosongs{
    margin-top:200px;
  }
  .historybtn{
    margin-top: 50px!important;
  }
  .info-show-song{
    & .soustitreimage{
      width: 700px!important;
      margin: 0 auto;
    }
    & .q-video{
      width:700px!important;
      margin: 0 auto;
    }
  }
}
@media (min-width:320px)  { /* smartphones, iPhone, portrait 480x320 phones */ }
@media (min-width:481px)  { /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */ }
@media (min-width:641px)  { /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */ }
@media (min-width:961px)  { /* tablet, landscape iPad, lo-res laptops ands desktops */ }
@media (min-width:1025px) { /* big landscape tablets, laptops, and desktops */ }
@media (min-width:1281px) { /* hi-res laptops and desktops */ }

</style>



// WEBPACK FOOTER //
// Info.vue?0be8daac